import { render } from "./Inquiry.vue?vue&type=template&id=267c420a&scoped=true&ts=true"
import script from "./Inquiry.vue?vue&type=script&lang=ts"
export * from "./Inquiry.vue?vue&type=script&lang=ts"

import "./Inquiry.vue?vue&type=style&index=0&id=267c420a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267c420a"]])

export default __exports__